import { CertificationCreateRequest } from '../request-models/certification-create-request.model';
import { CertificationUpdateRequest } from '../request-models/certification-update-request.model';
import { omitUndefined } from './wire-value-utils';

/** Builds the PUT /admin/certifications/:id body: only the hub's writable fields that are set (`null` clears). */
export function toCertificationUpdateRequest(fields: CertificationUpdateRequest): CertificationUpdateRequest {
  return omitUndefined<CertificationUpdateRequest>({
    certificateNumber: fields.certificateNumber,
    issuedDate: fields.issuedDate,
    expirationDate: fields.expirationDate,
    issuingAuthority: fields.issuingAuthority,
    state: fields.state,
    documentUrl: fields.documentUrl,
    documentFileName: fields.documentFileName,
    notes: fields.notes,
    status: fields.status,
  });
}

/** Builds the POST /admin/certifications body from the named create fields only. */
export function toCertificationCreateRequest(fields: CertificationCreateRequest): CertificationCreateRequest {
  return omitUndefined<CertificationCreateRequest>({
    certificationType: fields.certificationType,
    ownerType: fields.ownerType,
    organizationId: fields.organizationId,
    profileId: fields.profileId,
    certificateNumber: fields.certificateNumber,
    issuedDate: fields.issuedDate,
    expirationDate: fields.expirationDate,
    issuingAuthority: fields.issuingAuthority,
    state: fields.state,
    documentUrl: fields.documentUrl,
    documentFileName: fields.documentFileName,
    notes: fields.notes,
    previousCertificationId: fields.previousCertificationId,
  });
}
